import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Brand, PrimaryButton } from "../components/UI";
import { registerUser } from "../services/auth";
import { useApp } from "../store";

import "../css/Register.css";
export default function Register() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const redirectTo =
    new URLSearchParams(location.search).get("redirect") || "/home";
  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function change(name, value) {
    setForm((current) => ({ ...current, [name]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    setError("");
    const mobile = form.mobile.replace(/\D/g, "");
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      setError("Enter a valid 10-digit mobile number.");
      return;
    }

    setLoading(true);
    try {
      const user = await registerUser({ ...form, mobile });
      setUser(user);
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(err?.message || "Unable to create account. Please try again.");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="auth-page-simple">
      <div className="auth-card-simple">
        <Brand />
        <span className="eyebrow">Fresh delivery, Pune</span>
        <h1>Create your account</h1>
        <p>Create your account to manage your deliveries.</p>

        <form onSubmit={submit} className="form-card">
          <label className="form-label">Full name</label>
          <input
            className="form-control form-control-lg mb-3"
            value={form.name}
            onChange={(e) => change("name", e.target.value)}
            required
            autoComplete="name"
          />

          <label className="form-label">Mobile number</label>
          <input
            className="form-control form-control-lg mb-3"
            type="tel"
            inputMode="numeric"
            maxLength={10}
            placeholder="10-digit mobile number"
            value={form.mobile}
            onChange={(e) =>
              change("mobile", e.target.value.replace(/\D/g, "").slice(0, 10))
            }
            required
            autoComplete="tel"
          />

          <label className="form-label">Email</label>
          <input
            className="form-control form-control-lg mb-3"
            type="email"
            value={form.email}
            onChange={(e) => change("email", e.target.value)}
            required
            autoComplete="email"
          />

          <label className="form-label">Password</label>
          <input
            className="form-control form-control-lg mb-3"
            type="password"
            minLength={6}
            value={form.password}
            onChange={(e) => change("password", e.target.value)}
            required
            autoComplete="new-password"
          />

          {error && <div className="alert alert-danger">{error}</div>}
          <PrimaryButton
            type="submit"
            className="w-100 btn-lg"
            disabled={loading}
          >
            {loading ? "Please wait…" : "Create account"}
          </PrimaryButton>
        </form>

        <p className="text-center mt-3 mb-0">
          Already have an account?{" "}
          <Link to={`/login?redirect=${encodeURIComponent(redirectTo)}`}>
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}
